module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/axios/index.js